import AddIcon from "@mui/icons-material/Add";
import GroupsSharpIcon from "@mui/icons-material/GroupsSharp";
import TransferWithinAStationSharpIcon from "@mui/icons-material/TransferWithinAStationSharp";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useCallback } from "react";
import {
  DISPLAY_MODE_COMMITTEE,
  DISPLAY_MODE_SHARINGS,
} from "models/deals/deals-page";
import Highlight from "components/ui/atoms/Highlight";
import {
  TopRightMenu,
  TopRightMenuItem,
} from "components/ui/molecules/TopRightMenu";
import { useModal } from "@ebay/nice-modal-react";

const DealHeader = ({ displayMode, setDisplayMode }) => {
  const theme = useTheme();
  const dealModal = useModal("DealDrawer");

  const toggleDisplayMode = useCallback(
    (newDisplayMode) => {
      if (newDisplayMode === displayMode) setDisplayMode("");
      else setDisplayMode(newDisplayMode);
    },
    [displayMode],
  );

  return (
    <Grid container spacing={2} alignItems="center" sx={{ width: "100%" }}>
      <Grid>
        <Highlight color={theme.palette_custom.lightGreen}>Deal</Highlight>
      </Grid>
      <Grid ml="auto">
        <TopRightMenu style={{ marginLeft: "auto" }}>
          <TopRightMenuItem
            endIcon={<AddIcon sx={{ scale: "0.8" }} />}
            onClick={() => {
              dealModal.show({ formType: "create" });
            }}
          >
            Create
          </TopRightMenuItem>
          <TopRightMenuItem
            selected={displayMode == DISPLAY_MODE_COMMITTEE}
            onClick={() => toggleDisplayMode(DISPLAY_MODE_COMMITTEE)}
            endIcon={<GroupsSharpIcon sx={{ scale: "0.8" }} />}
            alwaysShow
          >
            Committee
          </TopRightMenuItem>
          <TopRightMenuItem
            selected={displayMode == DISPLAY_MODE_SHARINGS}
            onClick={() => toggleDisplayMode(DISPLAY_MODE_SHARINGS)}
            endIcon={<TransferWithinAStationSharpIcon sx={{ scale: "0.8" }} />}
            alwaysShow
          >
            Sharrings
          </TopRightMenuItem>
        </TopRightMenu>
      </Grid>
    </Grid>
  );
};

export default DealHeader;
